import { platformAdvantages } from '@/mocks/home';

export default function AdvantageSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
            为什么选择我们
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            开元体育 · 专业值得信赖
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base">
            我们致力于为每一位体育爱好者打造极致的在线体育体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {platformAdvantages.map((adv) => (
            <div
              key={adv.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-5">
                <i className={`${adv.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-3">{adv.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{adv.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}